var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Select, Store } from '@ngxs/store';
import { DriveState } from '../../state/drive-state';
import { Observable } from 'rxjs';
var EntryDragPreviewComponent = /** @class */ (function () {
    function EntryDragPreviewComponent(store) {
        this.store = store;
        this.className = 'files-grid-item-footer';
    }
    Object.defineProperty(EntryDragPreviewComponent.prototype, "dragging", {
        get: function () {
            return !this.store.selectSnapshot(DriveState.dragging);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Select(DriveState.selectedEntries),
        __metadata("design:type", Observable)
    ], EntryDragPreviewComponent.prototype, "entries", void 0);
    return EntryDragPreviewComponent;
}());
export { EntryDragPreviewComponent };
